import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "editor-box"
};
var _hoisted_2 = {
  class: "editor-box-content"
};
var _hoisted_3 = {
  key: 0,
  style: {
    "color": "#bbbbbb"
  }
};
var _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$options.emptyContent && $props.edit ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($options.tipContent) + "...", 1)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    contenteditable: "false",
    translate: "no",
    class: "tiptap ProseMirror",
    innerHTML: $options.html
  }, null, 8, _hoisted_4))])]);
}